import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { AutoComplete } from "antd";
import * as XLSX from "xlsx";

const ProcurementTemplateReport = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const redirectBasedOnUseCase = () => {
    const useCase = localStorage.getItem("useCase");

    switch (useCase) {
      case "Procurement":
        navigate("/fmnmis");
        break;

      case "Seed Production":
        navigate("/SeedMIS");
        break;

      case "Agri Promoter":
        navigate("/agrimis");
        break;

      case "Research Program":
        navigate("/researchProgramMIS");
        break;

      default:
        navigate("/fmnmis");
        break;
    }
  };

  const handleButtonClick = () => {
    redirectBasedOnUseCase();
  };

  const [employeeId, setEmployeeId] = useState(0);
  const [loading, setLoading] = useState(false);
  const [employeeData, setEmployeeData] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [stateName, setStateName] = useState();
  const [stateData, setStatedata] = useState([]);

  const [farmerNumber, setFarmerNumber] = useState("");

  const [farmerData, setFarmerData] = useState();

  const [showDateFilter, setShowDateFilter] = useState(false);

  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };

  const [data, setData] = useState([]);

  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange", e.target.value);
    setSelectedFromDate(e.target.value);
    setData([]);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
    setData([]);
  };

  // var date =date.setDate(date.getDate() + 10);

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate", toDate);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getProcurementTemplateData } = useHttp();

  const fillProcurementTemplateData = (employeeId, regionId, farmerNo) => {
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }
    if (farmerNo != "") {
      urlfilter = urlfilter + `&farmerNo=${farmerNo}`;
    }
    if (
      stateName &&
      typeof stateName === "string" &&
      stateName.trim().length > 0
    ) {
      const sanitizedState = stateName.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }

    var url = `/api/farmerProcurementTemplateReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getProcurementTemplateData(
      {
        url: url,
      },
      (data) => {
        // console.log("reportdata", data);
        setData(data);
      }
    );
  };

  // const excelDownload = async (
  //   employeeId,
  //   stateName,
  //   farmerNo,
  //   getType = "Excel"
  // ) => {
  //   setLoading(true);
  //   var urlfilter = "";

  //   if (showDateFilter) {
  //     urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
  //     urlfilter = urlfilter + `&toDate=${selectedToDate}`;
  //   }

  //   if (employeeId > 0) {
  //     urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
  //   }

  //   if (regionId > 0) {
  //     urlfilter = urlfilter + `&regionId=${regionId}`;
  //   }
  //   if (farmerNo != "") {
  //     urlfilter = urlfilter + `&farmerNo=${farmerNo}`;
  //   }

  //   if (getType != "") {
  //     urlfilter = urlfilter + `&getType=${getType}`;
  //   }

  //   if (
  //     stateName &&
  //     typeof stateName === "string" &&
  //     stateName.trim().length > 0
  //   ) {
  //     const sanitizedState = stateName.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
  //     urlfilter = urlfilter + `&stateName=${sanitizedState}`;
  //   }

  //   var url = `${
  //     process.env.REACT_APP_BASE_URL
  //   }/api/farmerProcurementTemplateReport/?orgId=${localStorage.getItem(
  //     "orgId"
  //   )}&empId=${localStorage.getItem("empId")}${urlfilter}`;

  //   try {
  //     const response = await fetch(url, {
  //       method: "GET",
  //       "Content-Type":
  //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //       authorization: `Bearear ${localStorage.getItem("token")}`,
  //     }); 

  //     if (!response.ok) {
  //       console.error(`Error ${response.status}: ${response.statusText}`);
  //       setLoading(false);
  //     }

  //     const blob = await response.blob();

  //     const downloadUrl = window.URL.createObjectURL(blob);

  //     console.log(downloadUrl);

  //     const link = document.createElement("a");
  //     link.href = downloadUrl;
  //     link.download = "ProcurementTemplateReport.xlsx"; 
  //     document.body.appendChild(link);
  //     link.click();
  //     window.URL.revokeObjectURL(downloadUrl);
  //     document.body.removeChild(link);
  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //     console.error("Error downloading file:", error);
  //   }
  // };

  useEffect(() => {
    fillProcurementTemplateData(0, 0, "");
  }, [getProcurementTemplateData]);

  const fieldsToExport = [
    "procurementTempDate",
    "createdByName",
    "farmerType",
    "state",
    "lga",
    "village",
    "farmerName",
    "farmerNo",
    "mobileNumber",
    "category",
    "warehouseName",
    "grainWithAMoistureContentAbove",
    "presenceOfInsect",
    "screenings",
    "foreignWheatGrainsPresent",
    "cropVariety",
    "quantityDeliveredInBags",
    "quantityDeliveredInKg",
    "useFMANSacks",
    "quantityDeductedForSacksInKg",
    "loanHectareSize",
    "loanQuantityDeductedInKg",
    "quantityBalanceInKg",
    "repaidLoanInFull",
    "outstandingLoan",
    "remainingLoanAmount",
    "useFMANHarvestingServices",
    "harvestingServices",
    "hectaresHarvested",
    "bagsThreshed",
    "quantityOfGrainsReceivedForHarvestingInKg",
    "dateOfHarvesting",
    "priceForExcessGrain",
    "paymentDueToFarmer",
    "paymentMethod",
    "bankName",
    "accountNumber",
    "nameOnTheAccount",
    "createdDate",
    "grainCollectionFormAttachment", // New field for the image URL
    "grainBagsAttachment", // New field for the image URLs
  ];

  const customHeaders = [
    "Date",
    "Field Agent Name",
    "Farmer Type",
    "state",
    "LGA",
    "Village",
    "Farmer Name",
    "Farmer's ID",
    "Mobile Number",
    "Farmer's Category",
    "Receiving Store",
    "Quality Check - Moisture Level",
    "Quality check - Presence of Insects",
    "Quality Check - Screenings",
    "Quality Check - Foreign Wheat Grains Present?",
    "Variety Delivered",
    "Total quantity delivered (in bags)",
    "Total quantity delivered (in KG)",
    "Did Farmer use FMAN Sacks?",
    "Quantity deducted for Sacks (KG)",
    "What is the Loan Hectare Size Taken this Season",
    "Loan quantity deducted (in KG)",
    "Quantity Balance (in KG)",
    "Did farmer repaid loan in full?",
    "Loan balance ",
    "Remaining Loan",
    "Did farmer use FMAN Harvesting/Threshing services?",
    "Which of the Harvesting services?",
    "Combine Harvester - How many hectares harvested?",
    "Thresher - How many bags threshed (Round bags to nearest 0.5 or full bag)?",
    "Quantity of grains received for harvesting/threshing services (in kg)",
    "Date of threshing/harvesting",
    "Price for excess grain (NGN per KG)",
    "Payment due to farmer for excess grains delivered at the current buying rate per KG",
    "Payment Method",
    "Bank Name",
    "Account/Wallet Number",
    "Name on the Account",
    "Created Date",
    "Capture Image of Grain Collection Form", // New header for image URL
    "Capture Image of Grain Bags", // New header for multiple image URLs
  ];

  const handleExportExcel = () => {
    const filename = "ProcurementTemplateReport.xlsx";
    // Console log to check data being passed for export
    // console.log(fieldsToExport, customHeaders);

    convertToExcel(data, fieldsToExport, filename, customHeaders);
  };

  // Function to handle exporting to Excel with image URLs
  const convertToExcel = (data, fieldsToExport, filename, customHeaders) => {
    const addHttpPrefix = (url) => {
      var fpath="/api/filedownload/";
      if (url) {
        if (!url.startsWith("http://") && !url.startsWith("https://")) {
          return `${process.env.REACT_APP_BASE_URL}${fpath}${url}`;
          // return `${process.env.REACT_APP_FILE_URL}${url}`;
        }
        return url;
      }
      return "";
    };
  
    const getDownloadableLink = (url) => addHttpPrefix(url);
  
    const createHeaders = (fieldsToExport) => {
      return fieldsToExport.map((field) => {
        if (field === "grainCollectionFormAttachment" || field === "grainBagsAttachment") {
          return `${field} (Image)`;
        }
        return field;
      });
    };
  
    const exportData = data.map((item) => {
      return fieldsToExport.map((field) => {
        if (field === "grainCollectionFormAttachment" || field === "grainBagsAttachment") {
          const firstAttachment = item[field] && item[field].length > 0 ? item[field][0] : null;
          return firstAttachment ? getDownloadableLink(firstAttachment.urlAttachments) : "No Image";
        }
  
        if (item[field] === false) return "NO";
        if (item[field] === 0) return 0;
        return item[field] !== undefined ? item[field] : "NA";
      });
    });
  
    const headers = createHeaders(fieldsToExport);
  
    // Add hyperlinks for images
    const addHyperlinksToImages = (data, fieldsToExport, exportData, headers) => {
      const headerIndexMap = {};
      headers.forEach((header, index) => {
        headerIndexMap[header] = index;
      });
  
      data.forEach((item, rowIndex) => {
        fieldsToExport.forEach((field) => {
          if (field === "grainCollectionFormAttachment" || field === "grainBagsAttachment") {
            if (item[field] && item[field].length > 0) {
              const firstAttachment = item[field][0]; // Only take the first image
              if (firstAttachment) {
                const url = getDownloadableLink(firstAttachment.urlAttachments);
                const columnIndex = headerIndexMap[`${field} (Image)`];
                exportData[rowIndex][columnIndex] = {
                  t: "s",
                  v: url,
                  l: { Target: url, Tooltip: "Click to download the image" },
                };
              }
            }
          }
        });
      });
    };
  
    addHyperlinksToImages(data, fieldsToExport, exportData, headers);
  
    // Create Excel sheet
    const ws = XLSX.utils.aoa_to_sheet([headers, ...exportData]);
    ws["!cols"] = headers.map((header) => ({
      wch: Math.max(header.length + 5, 15), // Minimum width of 15 for readability
    }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Procurement Data");
  
    // Save the file
    XLSX.writeFile(wb, filename);
  };
  

  const excelDownload = async (
    employeeId,
    stateName,
    farmerNo,
    getType = "Excel"
  ) => {
    setLoading(true);
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }
    if (farmerNo != "") {
      urlfilter = urlfilter + `&farmerNo=${farmerNo}`;
    }

    if (getType != "") {
      urlfilter = urlfilter + `&getType=${getType}`;
    }

    if (
      stateName &&
      typeof stateName === "string" &&
      stateName.trim().length > 0
    ) {
      const sanitizedState = stateName.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }

    var url = `${
      process.env.REACT_APP_BASE_URL
    }/api/farmerProcurementTemplateReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        "Content-Type":
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        authorization: `Bearear ${localStorage.getItem("token")}`,
      });

      if (!response.ok) {
        console.error(`Error ${response.status}: ${response.statusText}`);
        setLoading(false);
      }

      const blob = await response.blob();

      const downloadUrl = window.URL.createObjectURL(blob);

      console.log(downloadUrl);

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = "ProcurementTemplateReport.xlsx";
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(downloadUrl);
      document.body.removeChild(link);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error downloading file:", error);
    }
  };

  // const handleExportExcel = () => {
  //   const filename = "ProcurementTemplateReport.xlsx";
  //   //console.log(fieldsToExport, customHeaders);

  //   convertToExcel(data, fieldsToExport, filename, customHeaders);
  // };

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (state) => {
    var urlfilter = "";

    if (state && typeof state === "string" && state.trim().length > 0) {
      const sanitizedState = state.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }
    getEmp(
      {
        url: `/api/employeeListForProcReort/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        setEmployeeAllData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  const { sendRequest: getStateData } = useHttp();
  useEffect(() => {
    getStateData(
      {
        url: `/api/stateLocation/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        console.log("state", data);

        setStatedata(data);
      }
    );
  }, [getStateData]);

  const { sendRequest: getRegion } = useHttp();
  useEffect(() => {
    getRegion(
      {
        url: `/api/procurementRegionList/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        //console.log("region", data);

        setRegionData(data.data);
      }
    );
  }, [getRegion]);

  const { sendRequest: getFarmerNumber } = useHttp();
  useEffect(() => {
    getFarmerNumber(
      {
        url: `/api/farmerNumberList/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem(
          "empId"
        )}&fieldExecutiveId=${employeeId}`,
      },
      (data) => {
        // console.log("farmerNumberList", data);

        setFarmerData(data);
      }
    );
  }, [employeeId]);

  const handleSearch = (value) => {
    setFarmerNumber(value);
    setData([]);
  };

  // const options = farmerData&&farmerData.map(item => ({ value: item.identificationNo }));

  const filteredOptions =
    farmerData &&
    farmerData
      .filter((item) => item.farmerNo.includes(farmerNumber))
      .map((item) => ({ value: item.farmerNo }));

  //console.log(filteredOptions);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">
              Procurement Template Report
            </label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>State</label>
                  <select
                    id="stateName"
                    className="form-control"
                    ref={(el) => (frmRef.current["stateName"] = el)}
                    value={stateName}
                    onChange={(e) => {
                      var sName = "";

                      if (e.target.value != "--Select--") {
                        sName = e.target.value;
                        console.log("sName", sName);
                      }
                      setStateName(sName);
                      EmployeeDetail(sName);
                      setData([]);
                      setEmployeeId(0);
                    }}
                  >
                    <option value="">Select</option>
                    {stateData &&
                      stateData.map((x) => (
                        <option
                          key={x.stateName}
                          user-id={x.stateName}
                          value={x.stateName}
                        >
                          {x.stateName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"executive_officer"}>
                    {"Procurement Officer"}
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;

                      setEmployeeId(userid);
                      setData([]);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <label htmlFor="farmer_number">Farmer Number</label>
                <AutoComplete
                  className="form-control"
                  style={{ height: "30px" }}
                  value={farmerNumber}
                  options={filteredOptions}
                  placeholder="Farmer Number"
                  onChange={handleSearch}
                />
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"date_filter"}>{"Apply Date Filter"}</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      {" "}
                      <label htmlFor={"from_date"}>{"From Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor={"to_date"}>{"To Date"}</label>

                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="col-md-3  text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillProcurementTemplateData(
                        employeeId,
                        regionId,
                        farmerNumber
                      );
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
              <button
                type="button"
                className="btn btn-sm btn-warning mx-3"
                onClick={(e) => {
                  excelDownload(employeeId, stateName, farmerNumber, "Excel");
                }}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i>
                  </>
                ) : (
                  <>
                    <i className="fas fa-file-image"></i>
                  </>
                )}
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-lg">
                      <thead>
                        <tr className="table-header">
                          <th>Date</th>
                          <th>Created User (Field Agent Name)</th>
                          <th>Farmer Type</th>
                          <th>state</th>
                          <th>LGA</th>
                          <th>Village</th>
                          <th>Farmer Name</th>
                          <th>Farmer's ID</th>
                          <th>Mobile Number</th>
                          <th>Farmer's Category</th>
                          <th>Recieving Store</th>
                          <th>Quality Check - Moisture Level</th>
                          <th>Quality check - Presence of Insects</th>
                          <th>Quality Check - Screenings</th>
                          <th>Quality Check - Foreign Wheat Grains Present?</th>
                          <th>Variety Delivered</th>
                          <th>Total quantity delivered (in bags)</th>
                          <th>Total quantity delivered (in KG)</th>
                          <th>Did Farmer use FMAN Sacks?</th>
                          <th>Quantity deducted for Sacks (KG)</th>
                          <th>
                            What is the Loan Hectare Size Taken this Season
                          </th>
                          <th>Loan quantity deducted (in KG)</th>
                          <th>Quantity Balance (in KG)</th>
                          <th>Did farmer repaid loan in full?</th>
                          <th>Loan balance </th>
                          <th>Remaining Loan</th>
                          <th>
                            Did farmer use FMAN Harvesting/Threshing services?
                          </th>
                          <th>Which of the Harvesting services?</th>
                          <th>
                            Combine Harvester - How many hectares harvested?
                          </th>
                          <th>
                            Thresher - How many bags threshed (Round bags to
                            nearest 0.5 or full bag)?
                          </th>
                          <th>
                            Quantity of grains received for harvesting/threshing
                            services (in kg)
                          </th>
                          <th>Date of threshing/harvesting</th>
                          <th>Price for excess grain (NGN per KG)</th>
                          <th>
                            Payment due to farmer for excess grains delivered at
                            the current buying rate per KG
                          </th>
                          <th>Payment Method</th>
                          <th>Bank Name</th>
                          <th>Account/Wallet Number</th>
                          <th>Name on the Account</th>
                          <th>Created Date</th>
                          <th>Capture Image of Grain Collection Form</th>
                          <th>Capture Image of Grain Bags</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td>{itm.procurementTempDate}</td>
                                <td>{itm.createdByName}</td>
                                <td>{itm.farmerType}</td>
                                <td>{itm.state}</td>
                                <td>{itm.lga}</td>
                                <td>{itm.village}</td>
                                <td>{itm.farmerName}</td>
                                <td>{itm.farmerNo}</td>
                                <td>{itm.mobileNumber}</td>
                                <td>{itm.category}</td>
                                <td>{itm.warehouseName}</td>
                                <td>{itm.grainWithAMoistureContentAbove}</td>
                                <td>{itm.presenceOfInsect}</td>
                                <td>{itm.screenings}</td>
                                <td>{itm.foreignWheatGrainsPresent}</td>
                                <td>{itm.cropVariety}</td>
                                <td>{itm.quantityDeliveredInBags} </td>
                                <td>{itm.quantityDeliveredInKg} </td>
                                <td>{itm.useFMANSacks ? "yes" : "no"} </td>
                                <td>{itm.quantityDeductedForSacksInKg}</td>
                                <td>{itm.loanHectareSize} </td>
                                <td>{itm.loanQuantityDeductedInKg}</td>
                                <td>{itm.quantityBalanceInKg}</td>
                                <td>{itm.repaidLoanInFull ? "yes" : "no"}</td>
                                <td>{itm.outstandingLoan}</td>
                                <td>{itm.remainingLoanAmount}</td>
                                <td>
                                  {itm.useFMANHarvestingServices ? "yes" : "no"}
                                </td>
                                <td>{itm.harvestingServices}</td>
                                <td>{itm.hectaresHarvested}</td>
                                <td>{itm.bagsThreshed}</td>
                                <td>
                                  {
                                    itm.quantityOfGrainsReceivedForHarvestingInKg
                                  }
                                </td>
                                <td>{itm.dateOfHarvesting}</td>
                                <td>{itm.priceForExcessGrain}</td>
                                <td>{itm.paymentDueToFarmer}</td>
                                <td>{itm.paymentMethod}</td>
                                <td>{itm.bankName}</td>
                                <td>{itm.accountNumber}</td>
                                <td>{itm.nameOnTheAccount}</td>
                                <td>{itm.createdDate}</td>
                                <td>
                                  {itm.grainCollectionFormAttachment &&
                                  itm.grainCollectionFormAttachment.length >
                                    0 ? (
                                    <div
                                      style={{
                                        display: "grid",
                                        gridTemplateColumns: "repeat(2, auto)",
                                        gap: "5px",
                                      }}
                                    >
                                      {itm.grainCollectionFormAttachment.map(
                                        (attachment, index) => {
                                          // Check if `urlAttachments` exists and construct the image URL
                                          const imageUrl =
                                            attachment.urlAttachments
                                              ? attachment.urlAttachments.startsWith(
                                                  "http"
                                                )
                                                ? attachment.urlAttachments
                                                : `${process.env.REACT_APP_FILE_URL}${attachment.urlAttachments}`
                                              : null;

                                          return (
                                            imageUrl && (
                                              <img
                                                key={index}
                                                src={imageUrl}
                                                alt="Grain Collection Form"
                                                style={{
                                                  width: "50px",
                                                  height: "auto",
                                                  margin: "2px",
                                                }}
                                              />
                                            )
                                          );
                                        }
                                      )}
                                    </div>
                                  ) : (
                                    "NA"
                                  )}
                                </td>
                                <td>
                                  {itm.grainBagsAttachment &&
                                  itm.grainBagsAttachment.length > 0 ? (
                                    <div
                                      style={{
                                        display: "grid",
                                        gridTemplateColumns: "repeat(2, auto)",
                                        gap: "5px",
                                      }}
                                    >
                                      {itm.grainBagsAttachment.map(
                                        (attachment, index) => {
                                          // Check if `urlAttachments` exists and construct the image URL
                                          const imageUrl =
                                            attachment.urlAttachments
                                              ? attachment.urlAttachments.startsWith(
                                                  "http"
                                                )
                                                ? attachment.urlAttachments
                                                : `${process.env.REACT_APP_FILE_URL}${attachment.urlAttachments}`
                                              : null;

                                          return (
                                            imageUrl && (
                                              <img
                                                key={index}
                                                src={imageUrl}
                                                alt="Grain Bags"
                                                style={{
                                                  width: "50px",
                                                  height: "auto",
                                                  margin: "2px",
                                                }}
                                              />
                                            )
                                          );
                                        }
                                      )}
                                    </div>
                                  ) : (
                                    "NA"
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ProcurementTemplateReport;